module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzkot1.6d753f68.jpg";